import { maxLengthParser, onlyNumbersParser } from '../common/parse';

export const formatCardNumber = (value: string) => (value.match(/[\d]{1,4}/g) || []).join(' ');
export const getCardNumberParser = (length: number) => (value: string) =>
  maxLengthParser(onlyNumbersParser(value), length);
